import {resolveStringPathWithSpaceId} from "./resolvePathWithSpaceId";

export function isUrlActive(currentUrl: string, spaceId: string, toUrl: string, exact: boolean) {
    const resolvedToUrl = toUrl ? resolveStringPathWithSpaceId(toUrl, spaceId) : toUrl;
    return exact ? currentUrl === resolvedToUrl : currentUrl.startsWith(resolvedToUrl);
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Navigation/isUrlActive.tsx